module.exports = __webpack_public_path__ + "static/img/default_star.848ff06.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/defaultTip/img/default_star.jpg
// module id = oE4q
// module chunks = 27